import RequestToConnect from './RequestToConnect';
import { requestToConnect } from 'actions/payments';
import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';

export default connect(null, { setPopUp, onSubmit: requestToConnect })(RequestToConnect);



// WEBPACK FOOTER //
// ./src/components/Payments/RequestToConnect/index.js